import { useQuery } from "@tanstack/react-query";
import {
  getCVEResults,
  getInsights,
  getInsightsGraph,
  getInsightsSeverityGraph,
  getRiskScore,
  getUserVulnerabilities,
} from "../../api";

export const useGetInsights = () => {
  const query = useQuery({
    queryKey: ["insights"],
    queryFn: () => getInsights(),
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};

export const useGetInsightsGraph = () => {
  const query = useQuery({
    queryKey: ["insights-graph"],
    queryFn: () => getInsightsGraph(),
  });
  return {
    isGraphLoading: query.isPending,
    isGraphSuccess: query.isSuccess,
    isGraphError: query.isError,
    graphData: query.data,
    refetch: query.refetch,
  };
};

export const useGetInsightsSeverityGraph = (startDate, endDate) => {
  const query = useQuery({
    queryKey: ["insights-severity-graph"],
    queryFn: () => getInsightsSeverityGraph(startDate, endDate),
  });
  return {
    isGraphLoading: query.isPending,
    isGraphSuccess: query.isSuccess,
    isGraphError: query.isError,
    graphData: query.data,
    refetch: query.refetch,
  };
};

export const useGetRiskScore = () => {
  const query = useQuery({
    queryKey: ["riskScore"],
    queryFn: () => getRiskScore(),
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};

export const useGetCVEResults = (cve, options) => {
  const query = useQuery({
    queryKey: ["cve-results", cve],
    queryFn: () => getCVEResults(cve),
    ...options,
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};

export const useGetUserVulnerabilities = (page, severity, status) => {
  const query = useQuery({
    queryKey: ["user_vuln", page, severity, status],
    queryFn: () => getUserVulnerabilities(page, severity, status),
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};
